import React from 'react';

const TableSkeleton = ({ rows = 5 }) => {
    return (
        <>
            {Array.from({ length: rows }).map((_, index) => (
                <tr key={index}>
                    <td>
                        <div style={{ width: '120px', height: '16px', background: '#e2e8f0', borderRadius: '4px' }}></div>
                    </td>
                    <td>
                        <div style={{ width: '150px', height: '16px', background: '#e2e8f0', marginBottom: '8px', borderRadius: '4px' }}></div>
                        <div style={{ width: '100px', height: '12px', background: '#e2e8f0', borderRadius: '4px' }}></div>
                    </td>
                    <td>
                        {/* Prompt cell style mostly */}
                        <div style={{ width: '60%', height: '24px', background: '#e2e8f0', borderRadius: '4px' }}></div>
                    </td>
                    <td>
                        <div style={{ width: '80px', height: '24px', background: '#e2e8f0', borderRadius: '12px' }}></div>
                    </td>
                    <td>
                        {/* Button */}
                        <div style={{ width: '80px', height: '30px', background: '#e2e8f0', borderRadius: '6px' }}></div>
                    </td>
                </tr> 
            ))}
        </>
    );
};

export default TableSkeleton;
